module.exports = __webpack_public_path__ + "img/mapeamento_de_fluxo_de_pedestres.3584e1ba.png";